import { PATTERN_LABEL, imageUrl, type Pattern } from '../lib/program'

/**
 * Hareket görseli — görseli olmayanlar için yer tutucu.
 *
 * Elle yazdığımız hareketlerin (bantlı sırt/göğüs) görseli yok: lisansı
 * belirsiz GIF/fotoğraf taşımak yerine anlatımı Türkçe yazmayı seçtik.
 * Boş bir gri kutu "yüklenemedi" gibi duruyordu; onun yerine kalıbın adını
 * yazan bir yer tutucu koyuyoruz — bilgi taşıyor ve bozuk görünmüyor.
 */
export function ExerciseImage({ images, pattern, alt = '', className, width, height }: {
  images: string[]
  pattern: Pattern | string
  alt?: string
  className?: string
  width?: number
  height?: number
}) {
  if (images.length > 0) {
    return (
      <img
        className={className}
        src={imageUrl(images[0])}
        alt={alt}
        loading="lazy"
        width={width}
        height={height}
        onError={(e) => { (e.target as HTMLImageElement).style.visibility = 'hidden' }}
      />
    )
  }

  return (
    <div className={`noimg${className ? ' ' + className : ''}`}
         style={width ? { width, height } : undefined}
         aria-hidden>
      <span>{PATTERN_LABEL[pattern as Pattern] ?? 'Hareket'}</span>
    </div>
  )
}
